import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { cls } from '@mssgme/helpers';
import { usePageColors } from '../../hooks';

import styles from './Divider.scss';

export const Divider = ({ style: baseStyle, ...props }) => {
    const colors = usePageColors();
    const style = useMemo(() => ({ borderTop: `1px solid ${colors.color}`, ...baseStyle }));

    return <div style={style} {...cls(styles.root, props)} />;
};

Divider.propTypes = {
    style: PropTypes.object,
};
